export default function() {
    if(document.querySelector('.report-user')) {
        let userReportButton = document.querySelector('.report-user');
        let modalName = userReportButton.getAttribute('data-modal');

        userReportButton.addEventListener('click', function( event ) {
            event.preventDefault();
            document.querySelector('#' + modalName).classList.add('-active');
        })
    }

    if(document.querySelector('.report-picture')) {
        let pictureReportButton = document.querySelector('.report-picture');
        let modalName = pictureReportButton.getAttribute('data-modal');
        let pictureId = pictureReportButton.getAttribute('data-id');

        document.querySelector('.report-picture').addEventListener('click', function( event ) {
            event.preventDefault();

            document.querySelector('#'+modalName).classList.add('-active');
            document.querySelector('#'+modalName).querySelector('input[name=picture_id]').value = pictureId;
        })
    }

    if(document.querySelector('.delete-user')) {
        let deleteUserButton = document.querySelector('.delete-user');
        let modalName = deleteUserButton.getAttribute('data-modal');

        document.querySelector('.delete-user').addEventListener('click', function( event ) {
            event.preventDefault();

            document.querySelector('#'+modalName).classList.add('-active');
        })
    }

    if(document.querySelector('.create-suggestion')) {
        let createSuggestButton = document.querySelector('.create-suggestion');
        let modalName = createSuggestButton.getAttribute('data-modal');

        createSuggestButton.addEventListener('click', function( event ) {
            event.preventDefault();
            document.querySelector('#' + modalName).classList.add('-active');
        })
    }

    document.querySelectorAll('.modal-close').forEach( function( element ) {
        element.addEventListener('click', function( event ) {
            event.preventDefault();
            event.target.closest('.modals').classList.remove('-active');
        });
    });

    document.querySelectorAll('.modals').forEach( function( element ) {
        element.addEventListener('click', function( event ) {
            if(event.target === element) {
                event.preventDefault();
                element.classList.remove('-active');
            }
        });
    });
}
